// Lógica única para el estado de acceso de un alumno.
// Se deriva SOLO de dos columnas de students, sin llamar a la edge:
//   - access_revoked_at
//   - access_expires_at
//
// Reglas:
//   - "retirado"  si access_revoked_at != null
//   - "caducado"  si access_revoked_at == null y access_expires_at != null
//                  y now >= access_expires_at
//   - "activo"    en cualquier otro caso

export const ACCESS_LABELS = {
  activo: "Activo",
  caducado: "Caducado",
  retirado: "Retirado",
};

export const ACCESS_COLORS = {
  activo: "bg-emerald-100 text-emerald-700",
  caducado: "bg-amber-100 text-amber-700",
  retirado: "bg-red-100 text-red-700",
};

export function getAccessStatus(student) {
  if (!student) return "activo";
  if (student.access_revoked_at) return "retirado";
  if (
    student.access_expires_at &&
    Date.now() >= new Date(student.access_expires_at).getTime()
  ) {
    return "caducado";
  }
  return "activo";
}

// Devuelve todo lo necesario para pintar el badge en el estilo de ETC.
export function getAccessBadge(student) {
  const status = getAccessStatus(student);
  return {
    status,
    label: ACCESS_LABELS[status],
    color: ACCESS_COLORS[status],
  };
}
